import React from "react";

export const TABLE_HEAD_CLASS =
  "border-b border-gray-200 bg-gray-50 px-3 py-2.5 text-left text-[11px] font-semibold uppercase tracking-wide text-gray-500";
export const TABLE_CELL_CLASS = "px-3 py-2.5 align-middle text-[13px] text-gray-700";

export function formatDate(value) {
  if (!value) return "—";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "—";
  return d.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
}

export function formatNumber(n) {
  if (n === "—" || n == null) return "—";
  return Number(n).toLocaleString();
}

const PROVIDER_INSIGHTS_MIN_INTAKE_YEAR = 2022;

function parseIntakeYear(intake) {
  const fromField = intake?.year;
  if (fromField != null && String(fromField).trim() !== "") {
    const parsed = parseInt(String(fromField), 10);
    if (!Number.isNaN(parsed)) return parsed;
  }
  const title = String(intake?.title ?? intake?.name ?? "");
  const match = title.match(/\b(20\d{2})\b/);
  return match ? parseInt(match[1], 10) : 0;
}

function parseIntakeQuarter(intake) {
  const fromField = intake?.quarter;
  if (fromField) {
    const match = String(fromField).match(/Q?([1-4])\b/i);
    if (match) return parseInt(match[1], 10);
  }
  const title = String(intake?.title ?? intake?.name ?? "");
  const match = title.match(/\bQ([1-4])\b/i);
  return match ? parseInt(match[1], 10) : 0;
}

/** Intakes for Provider Insights: 2022+ only, chronological (year then quarter). */
export function filterAndSortProviderInsightsIntakes(list = []) {
  if (!Array.isArray(list)) return [];
  return [...list]
    .filter((intake) => parseIntakeYear(intake) >= PROVIDER_INSIGHTS_MIN_INTAKE_YEAR)
    .sort((a, b) => {
      const yearDiff = parseIntakeYear(a) - parseIntakeYear(b);
      if (yearDiff !== 0) return yearDiff;
      const quarterDiff = parseIntakeQuarter(a) - parseIntakeQuarter(b);
      if (quarterDiff !== 0) return quarterDiff;
      return String(a?.title ?? a?.name ?? "").localeCompare(
        String(b?.title ?? b?.name ?? ""),
      );
    });
}

export function TruncateTooltip({ text, className = "", as = "span" }) {
  const value = text == null || text === "" ? "—" : String(text);
  const Tag = as;
  if (value === "—") {
    return <Tag className={className}>—</Tag>;
  }
  return (
    <Tag className={`${className} truncate`} title={value}>
      {value}
    </Tag>
  );
}

export function StatusBadge({ value, title }) {
  const v = Number(value);
  let className = "bg-slate-100 text-slate-700";
  if (v === 9) className = "bg-emerald-100 text-emerald-800";
  else if (v === 100 || v === 107) className = "bg-teal-100 text-teal-900";
  else if (v === 2 || v === 3) className = "bg-sky-100 text-sky-800";
  else if (v === 4 || v === 5) className = "bg-amber-100 text-amber-900";
  else if (v === 101 || v === 108) className = "bg-red-100 text-red-800";

  const label = title?.trim() || "—";

  return (
    <span
      className={`inline-flex max-w-[180px] truncate rounded px-1.5 py-0.5 text-[10px] font-semibold ${className}`}
      title={label}
    >
      {label}
    </span>
  );
}
